import React, { useContext, useEffect } from 'react'
import PropTypes from 'prop-types'
import { DataContext } from '../../context/DataContext'
import { usePayment } from '../../hook/payment/usePayment/usePayment'
import {
  OTHERS,
  PINFLAG_PAYMENT_OPTIONS
} from '../../constants/payment'
import { scrollToBottom } from '../../helpers/utils'
import { usePaymentHandlers } from '../../hook/payment/usePaymentHandlers'
import { PaymentMethodItem } from '@pinflag/pinflag-ui-kit'
import PaymentMethodForm from './PaymentMethodForm'

// Filter PINFLAG_PAYMENT_OPTIONS by the keys of ownPayments
const getPinflagPayments = (ownPayments, cmsPaymentMethods, nativePaymentEnabled) => {
  let availablePayments = PINFLAG_PAYMENT_OPTIONS.filter(
    (paymentOption) => ownPayments[paymentOption.type]
  )
  const hasOthersPayment =
    ownPayments.others &&
    Object.keys(ownPayments.others).every((key) => ownPayments.others[key])
  if (!hasOthersPayment || cmsPaymentMethods?.length === 0 || !nativePaymentEnabled) {
    availablePayments = availablePayments.filter(
      (paymentOption) => paymentOption.type !== OTHERS
    )
  }

  return availablePayments
}

export const getGatewayFromPaymentMethod = (ownPayments, paymentMethodOption) => {
  return paymentMethodOption.type !== OTHERS
    ? ownPayments[paymentMethodOption.type]
    : OTHERS
}

const PinflagPaymentMethodList = ({ scrapperClient }) => {
  const { cmsPaymentMethods, companyInfo } = useContext(DataContext)

  const { selectedPaymentOption, nativePaymentEnabled } = usePayment()
  const { onSelectPaymentMethod } = usePaymentHandlers({ scrapperClient })

  const { ownPayments } = companyInfo

  const pinflagPayments = getPinflagPayments(ownPayments, cmsPaymentMethods, nativePaymentEnabled)

  useEffect(() => {
    if (selectedPaymentOption === OTHERS) {
      scrollToBottom('pinflag-payment-list')
    }
  }, [selectedPaymentOption])

  return (
    <div className="flex flex-col gap-2 max-h-64 overflow-y-auto pinflag-payment-list">
      {pinflagPayments.map((paymentMethodOption, index) => (
        <div
          key={`payment-option-${index}`}
          className="flex flex-col gap-0 items-center justify-start w-full"
        >
          <PaymentMethodItem
            title={paymentMethodOption.title}
            subTitle={paymentMethodOption.subTitle}
            paymentMethodOption={paymentMethodOption}
            logo={paymentMethodOption.logo}
            logoWidth={paymentMethodOption.logoWidth}
            isSelected={paymentMethodOption.type === selectedPaymentOption}
            onClick={() => onSelectPaymentMethod(paymentMethodOption)}
          />
          {paymentMethodOption.type === selectedPaymentOption && (
            <PaymentMethodForm
              scrapperClient={scrapperClient}
              gateway={getGatewayFromPaymentMethod(ownPayments, paymentMethodOption)}
            />
          )}
        </div>
      ))}
    </div>
  )
}

PinflagPaymentMethodList.propTypes = {
  scrapperClient: PropTypes.string
}

export default PinflagPaymentMethodList
